import { EMediaType } from 'shared/components/NewbuildingGallery';
import { EVideoType } from 'shared/types/api-models/offer-card/v1/get-offer-data';

export const MAP_VIDEO_TYPE_TO_MEDIA_TYPE: Partial<Record<EVideoType, EMediaType>> = {
  [EVideoType.Youtube]: EMediaType.Video,
  [EVideoType.Vk]: EMediaType.VideoVk,
  [EVideoType.Rutube]: EMediaType.VideoRutube,
};

export const MIDDLE_BANNER_SLIDE_POSITION = 5;
export const MIDDLE_BANNER_SLIDE_LIMIT = 6;
